(function ($) {
  'use strict';

  /**
  * Main functionality should be in an 'init' function
  **/
  var initAccordions = function () {
    var container = $(this);

    var $accordionBtn = $('.accordion-trigger', container);
    var $accordionPanel = $('.accordion-panel', container);
    var $accordionExpand = $('.acc-expand', container);
    var $accordionCollapse = $('.acc-collapse', container);
    var TRANSITION_TIME = 250;

    container.on('click', '.accordion-trigger', function () {

      var $this = $(this);
      var $target = $this.next();
      var $parent = $this.parents('li');
      var $siblings = $this.parent().siblings();

      // open/close next() accordion
      if (!$target.hasClass('active')) {
        // close
        $accordionBtn.attr('aria-expanded', 'false');
        $accordionBtn.attr('aria-disabled', 'false');
        $accordionBtn.removeClass('open');
        $accordionPanel.removeClass('active').slideUp(TRANSITION_TIME);
        // open
        $target.addClass('active').slideDown(TRANSITION_TIME);
        $this.attr('aria-expanded', 'true');
        $this.attr('aria-disabled', 'true');
      }

      // toggle button
      if ($this.hasClass('open')) {
        // close accordion
        $this.removeClass('open');
        $target.removeClass('active').slideUp(TRANSITION_TIME);
        $this.attr('aria-expanded', 'false');
        $this.attr('aria-disabled', 'false');
        $parent.removeClass('open');
      }
      else {
        // open accordion
        $this.addClass('open');
        $parent.addClass('open');
        $siblings.removeClass('open');
        $target.addClass('active').slideDown(TRANSITION_TIME);
        $this.attr('aria-expanded', 'true');
        $this.attr('aria-disabled', 'true');
      }
    });

    // accessibility
    container.on('keydown', function (e) {
      // home key
      if (e.keyCode === 36) {
        e.preventDefault();
        $accordionBtn.get(0).focus();
      }

      // end key
      if (e.keyCode === 35) {
        e.preventDefault();
        $accordionBtn.last().focus();
      }
    });

    $accordionExpand.on('click', function () {
      var $listItems = $('li', container);
      var $accordionBtns = $('.accordion-trigger', container);
      var $accordionPanels = $('.accordion-panel', container);

      $listItems.addClass('open');
      $accordionBtns.addClass('open');
      $accordionPanels.addClass('active');
      $accordionPanels.slideDown(TRANSITION_TIME);
    });

    $accordionCollapse.on('click', function () {
      var $listItems = $('li', container);
      var $accordionBtns = $('.accordion-trigger', container);
      var $accordionPanels = $('.accordion-panel', container);

      $listItems.removeClass('open');
      $accordionBtns.removeClass('open');
      $accordionPanels.removeClass('active');
      $accordionPanels.slideUp(TRANSITION_TIME);
    });
  };

  /**
  * This is boilerplate: add a behavior to window.DP.behaviors
  **/
  window.DP.behaviors.accordions = {
    attach: function (context) {
      once('accordions', '.cc--accordions', context)
        .forEach((e) => {
          initAccordions.apply(e);
        });
      // $(context).find('.cc--accordions').once('accordions').each(function () {
      //   initAccordions.apply(this);
      // });
    }
  };

}(jQuery));
